import { ProductForecasts } from '@domain/sales/models/Forecasts';
import { ProductMapper } from '../../product/mappers/ProductMapper';
import { SalesForecastsDto } from '../dto/SalesForecastDTO';

export class SalesForecastMapper {
  static toModel(dto: SalesForecastsDto): ProductForecasts {
    return {
      product: ProductMapper.toModel(dto.product),
      weeks: dto.weeks.map(week => ({
        weekNumber: week.weekNumber,
        year: week.year,
        startDate: new Date(week.startDate),
        endDate: new Date(week.endDate),
        quantity: week.quantity,
      }))
    };
  }
} 